import { companyList } from '@/api/company';

const company = {
  state: {
    list: [],
    pager: {},
  },

  mutations: {
    SET_COMLIST: (state, list) => {
      state.list = list;
    },
    SET_COMPAGER: (state, pager) => {
      state.pager = {
        ...pager,
        showTotal: (total) => `共计 ${total} 条信息`,
      };
    },
  },
  actions: {
    async getCompanyList({ commit }, params) {
      const res = await companyList(params);
      if (res.code === 0) {
        commit('SET_COMLIST', res.data.docs);
        commit('SET_COMPAGER', res.data.pager);
      }
    },
  },
};
export default company;
